import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function JumboCard(props) {
    const icon = getImage(props.icon);
    const type = props.type;
    return (
        <div 
            className="text-white flex flex-col lg:flex-row lg:items-center lg:justify-between p-8 xs:py-12 xs:px-20 bg-no-repeat bg-cover overflow-hidden rounded-lg"
            style={{backgroundImage: `url(${props.background})`}}>
            <div className="w-full lg:w-2/3">
                <h2 className="text-4xl xs:text-6xl font-bold mb-4">{props.title}</h2>
                <p>{props.description}</p>
                <hr />
                <div className="text-xs mt-4 mb-10 flex flex-col sm:flex-row">
                  <h6><b>Instructor:</b> {props.instructor}</h6>
                  <h6 className="my-1 sm:mx-3 sm:my-0"><b>Category:</b> {props.category}</h6>
                  { type === "course" ? <h6><b>Duration:</b> {props.duration}</h6> : <h6><b>Total:</b> {props.total} Courses</h6> }
                 </div>
                <Link to="/premium" className="ia-green-button text-xl shadow-lg">Enroll Now</Link>
            </div>
            <div className="w-full mt-10 lg:mt-0 xs:w-2/3 lg:w-1/3 lg:pl-16">
                <GatsbyImage image={icon} alt="icon" />
            </div>
        </div>
    )
}